import { Modal } from "@/components/elements/Modal";
import { FCC } from "@/types/common";
import { Box, Typography, Link } from "@mui/material";
import { AppRoutes } from "@/routes/config";
import { getDynamicRoute } from "@/utils/url";
import { text } from "@/theme/colors";
import { TCheckCaseDuplicateDto } from "@/api/services/main/case/dtos/check-case-duplicate.dto";

type TDuplicateCaseModalProps = {
  open: boolean;
  onClose: () => void;
  duplicateCases: TCheckCaseDuplicateDto[];
  caseName: string;
  jobId: number;
};

export const DuplicateCaseModal: FCC<TDuplicateCaseModalProps> = ({ open, onClose, duplicateCases, caseName, jobId }) => {
  const handleCaseClick = (caseId: number) => {
    const detailRoute = getDynamicRoute(AppRoutes.caseEdit, { jobId: String(jobId), caseId: String(caseId) });
    window.open(detailRoute, "_blank");
  };

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      labelClose="閉じる"
      width={600}
      enableFooter={true}
      hiddenOkBtn={true}
      justifyBtnAction="center"
      title={
        <Box sx={{ flex: 1, textAlign: "left" }}>
          <Typography variant="head20Bold">エラー</Typography>
        </Box>
      }
    >
      <Box mb={2} sx={{ mt: 2 }}>
        <Typography variant="body1" sx={{ textAlign: "left", mb: 1 }}>
          案件名 （{caseName}）が
          {duplicateCases.map((caseItem) => (
            <Link
              key={caseItem.id}
              component="button"
              variant="body1"
              onClick={() => handleCaseClick(caseItem.id)}
              sx={{
                display: "inline-block",
                textDecoration: "underline",
                color: text.primary,
                cursor: "pointer",
                wordBreak: "break-word",
                "&:hover": {
                  textDecoration: "underline",
                },
                mb: 0.6,
              }}
            >
              {caseItem.name}
            </Link>
          ))}
          と重複しています。
        </Typography>
      </Box>
    </Modal>
  );
};
